module.exports = __webpack_public_path__ + "img/doc-checked.cddf7ebd.svg";